module.exports = __webpack_public_path__ + "img/tool02.314e61c0.png";